export default "/images/vendor/flag-icon-css/flags/1x1/lb.svg?940cc75a55e4b18f510a404301dd6e61";